import { render, staticRenderFns } from "./NovaTriagem.vue?vue&type=template&id=4385e112&"
import script from "./NovaTriagem.vue?vue&type=script&lang=js&"
export * from "./NovaTriagem.vue?vue&type=script&lang=js&"
import style0 from "./NovaTriagem.vue?vue&type=style&index=0&id=4385e112&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports